import * as React from 'react';

import {
  Badge,
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/cargofl-ui';
import { PageContainer } from '@/components/shell/page-container';
import { useAuditLog } from '@/lib/admin-api';

/** The verbs worth filtering by. Grouped the way someone investigating would ask. */
const ACTIONS = [
  { value: '', label: 'Everything' },
  { value: 'asset.assigned', label: 'Assets issued' },
  { value: 'asset.returned', label: 'Assets returned' },
  { value: 'asset.acknowledged', label: 'Receipt confirmed' },
  { value: 'asset.status_changed', label: 'Status changed' },
  { value: 'asset.created', label: 'Assets registered' },
  { value: 'asset.deleted', label: 'Assets deleted' },
  { value: 'employee.exited', label: 'Exits' },
  { value: 'employee.role_changed', label: 'Role changes' },
  { value: 'employee.code_changed', label: 'Employee ID changes' },
  { value: 'import.assets', label: 'Asset imports' },
  { value: 'import.employees', label: 'Employee imports' },
  { value: 'import.assignments', label: 'Assignment imports' },
];

export function AuditPage() {
  const [action, setAction] = React.useState('');
  const { data, isPending } = useAuditLog(action ? { action } : {});

  return (
    <PageContainer>
      <Card>
        <CardHeader className="pb-3">
          <div className="flex flex-wrap items-center justify-between gap-3">
            <div>
              <CardTitle className="text-sm">Audit log</CardTitle>
              <CardDescription className="text-xs">
                Append-only. Nothing in this system edits or deletes an entry — a log that
                can be changed answers nothing.
              </CardDescription>
            </div>
            <Select value={action || 'all'} onValueChange={(v) => setAction(v === 'all' ? '' : v)}>
              <SelectTrigger className="w-[220px]">
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                {ACTIONS.map((option) => (
                  <SelectItem key={option.value || 'all'} value={option.value || 'all'}>
                    {option.label}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
        </CardHeader>

        <CardContent className="pt-0">
          {isPending ? (
            <p className="py-8 text-center text-sm text-muted-foreground">Loading…</p>
          ) : data?.entries.length ? (
            <ul className="divide-y">
              {data.entries.map((entry) => (
                <li key={entry.id} className="flex flex-wrap items-baseline gap-3 py-2.5">
                  <span className="at-num w-[150px] shrink-0 text-xs text-muted-foreground">
                    {new Date(entry.createdAt).toLocaleString()}
                  </span>
                  <span className="min-w-0 flex-1 text-sm">{entry.summary}</span>
                  <Badge variant="soft-muted" className="rounded-full px-2 py-0 text-[10px]">
                    {entry.action}
                  </Badge>
                  <span className="w-[120px] shrink-0 text-right text-xs text-muted-foreground">
                    {entry.actorName ?? 'system'}
                  </span>
                </li>
              ))}
            </ul>
          ) : (
            <p className="py-8 text-center text-sm text-muted-foreground">
              Nothing recorded for that filter yet.
            </p>
          )}
        </CardContent>
      </Card>
    </PageContainer>
  );
}
